import ContainerLayout from "@/shared/components/ContainerLayout";
import { useUser } from "@/contexts/UserContext";
import { useRegionInvoiceData } from "@/domains/invoices/services/invoices";
import { Invoices } from "@/domains/invoices/components/Invoices";
import { useState } from "react";
import { subMonths } from "date-fns";
import { usePermissions } from "@/shared/hooks/use-permissions";
import { Feature, Permission } from "@/shared/types/permissionsTypes";
import { OrgType } from "@/shared/types/userRoleTypes";

const InvoicesPage = () => {
  const { selectedRegionCode } = useUser();
  const { hasPermission } = usePermissions();
  const defaultBillingPeriod = subMonths(new Date(), 1).toISOString().split("T")[0];

  const [selectedBillingPeriod, setSelectedBillingPeriod] = useState<string>(defaultBillingPeriod);

  const { data: invoices, isLoading, error, refetch } = useRegionInvoiceData(selectedRegionCode, selectedBillingPeriod);

  return (
    <ContainerLayout shouldShowSidebar={true} shouldAllowRegionChange={true} shouldAllowAccountChange={false}>
      <div className="flex flex-col flex-1 space-y-4 p-4">
        <Invoices
          selectedRegionCode={selectedRegionCode}
          invoices={invoices ?? []}
          isLoading={isLoading}
          error={error}
          hasPermission={hasPermission(OrgType.PLATFORM, Feature.INVOICES, Permission.MANAGE)}
          refetch={refetch}
          onBillingPeriodChange={(billingPeriod) => setSelectedBillingPeriod(billingPeriod)}
        />
      </div>
    </ContainerLayout>
  );
};

export default InvoicesPage;